<template>
  <el-dialog v-dialog-drag :title="title" :width="width" :visible="visible" :close-on-click-modal="false" @close="handleClose">
    <el-form ref="editForm" :model="data" :rules="rules" :inline="true" label-width="80px">
      <el-row>
        <el-col :span="24" style="text-align: center; margin-bottom: 10px">
          <span style="color: red" v-show="tips">{{ tips }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="货号：" prop="ItemNo">
            <el-input v-model="data.ItemNo" :disabled="!isNew" placeholder="请输入货号" style="width: 250px" />
          </el-form-item>
          <el-form-item label="商品价：" prop="Price">
            <el-input
              v-model="data.Price"
              v-format.float
              :disabled="$store.state.routes.systemSetting.IsHideProductPriceAuth"
              placeholder="请输入商品价"
              style="width: 250px"
            />
          </el-form-item>
          <el-form-item label="采购价：" prop="Cost">
            <el-input
              v-model="data.Cost"
              v-format.float
              :disabled="$store.state.routes.systemSetting.IsHideCostPriceAuth"
              placeholder="请输入采购价"
              style="width: 250px"
            />
          </el-form-item>
          <el-form-item label="客户价：" prop="SettlePrice">
            <el-select v-model="data.SettleType" style="width: 85px; margin-right: 5px">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-input
              v-model="data.SettlePrice"
              v-format.float
              :disabled="$store.state.routes.systemSetting.IsHideCustomerPriceAuth"
              :placeholder="
                data.SettleType == 0 ? (Number(data.Price - data.Discount) > 0 ? data.Price - data.Discount : 0) : '请输入优惠金额'
              "
              style="width: 160px"
            />
            元
          </el-form-item>
          <el-form-item label="供应商：">
            <el-autocomplete
              placeholder="供应商"
              v-model="data.DefaultSupplierName"
              style="width: 250px"
              :fetch-suggestions="loadSuppliers"
            />
          </el-form-item>
          <el-form-item label="颜色：">
            <dynamic-tags style="width: 450px" v-model="colors" title="添加颜色" :exten="{ visable: false }" @valueChange="colorsChange" />
          </el-form-item>
          <el-form-item label="尺码：">
            <dynamic-tags
              style="width: 450px"
              v-model="sizes"
              title="添加尺码"
              :exten="{ visable: true, title: '选择尺码' }"
              @valueChange="sizesChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6" style="text-align: center">
          <el-upload
            ref="uploadImage"
            class="avatar-uploader"
            accept="image/*"
            :action="uploadUrl"
            :headers="headers"
            :show-file-list="false"
            :on-success="uploadImgSuccess"
            :on-error="uploadImgError"
          >
            <img v-if="data.DefaultImage" :src="data.DefaultImage" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
      </el-row>
      <el-form-item label="备注：">
        <el-input type="textarea" :rows="2" v-model="data.Memo" style="width: 600px"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">关闭</el-button>
      <el-button
        type="primary"
        size="small"
        :loading="loading"
        :disabled="
          $store.state.routes.systemSetting.IsHideProductPriceAuth ||
          $store.state.routes.systemSetting.IsHideCostPriceAuth ||
          $store.state.routes.systemSetting.IsHideCustomerPriceAuth
        "
        @click="handleSave"
        >保存</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { submit } from '@/api/base'
import { baseURL, successCode } from '@/config'
import DynamicTags from './Tags.vue'
export default {
  name: 'ProductEditSimple',
  components: {
    DynamicTags,
  },
  data() {
    return {
      loading: false,
      visible: false,
      width: '800px',
      title: '新增商品',
      isNew: true,
      uploadUrl: baseURL + '/api/base/file/uploadImg?path=product',
      headers: {
        Authorization: 'Bearer ' + this.$store.getters['user/accessToken'],
      },
      initData: {
        ItemNo: '',
        Price: '',
        Cost: '',
        SettleType: 0,
        SettlePrice: '',
        Discount: 0,
        DefaultSupplierName: '',
        DefaultImage: '',
        Memo: '',
        Colors: [],
        Sizes: [],
      },
      data: {},
      suppliers: [],
      colors: [],
      sizes: [],
      rules: {
        ItemNo: [{ required: true, message: '请输入货号', trigger: 'blur' }],
        Price: [{ required: true, message: '请输入商品价', trigger: 'blur' }],
      },
      options: [
        { value: 0, label: '固定价' },
        { value: 1, label: '便宜' },
      ],
      tips: '',
    }
  },
  methods: {
    async fetchSuppliers() {
      const { data } = await submit('/api/purchase/supplier/getList', {
        CurrentPage: 1,
        PageSize: 1000,
      })
      data.datas.forEach(element => {
        element.value = element.SupplierName
      })
      this.suppliers = data.datas || []
    },
    createFilter(qs) {
      return supplier => {
        return supplier.value.toLowerCase().includes(qs.toLowerCase())
      }
    },
    async loadSuppliers(qs, cb) {
      const suppliers = this.suppliers
      var results = qs ? suppliers.filter(this.createFilter(qs)) : suppliers
      cb(results || [])
    },
    async initDialog(title, productID, addData = null) {
      this.visible = true
      if (title) {
        this.title = title
      }
      this.isNew = !productID
      if (this.isNew) {
        this.data = JSON.parse(JSON.stringify(this.initData))
        if (addData) {
          this.data.ItemNo = addData.ItemNo
          this.data.Colors = addData.Colors
          this.data.Sizes = addData.Sizes
          this.data.PurchaserID = addData.PurchaserID
          this.data.PurchaserName = addData.PurchaserName
        }
      } else {
        const { data } = await submit('/api/product/getInfo', {
          productID: productID,
          IncludeColorsAndSizes: true,
        })
        this.data = data
      }
      if (addData && addData.tips && !this.isNew) {
        this.tips = addData.tips
      } else {
        this.tips = ''
      }
      if (this.data.Colors) {
        this.colors = this.data.Colors.split(',')
      }
      if (this.data.Sizes) {
        this.sizes = this.data.Sizes.split(',')
      }
      await this.fetchSuppliers()
    },
    handleSave() {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return false
        if (!this.data.Colors && this.data.Sizes) {
          this.$message.error('颜色不能为空，请配置')
          return false
        }
        if (this.data.Colors && !this.data.Sizes) {
          this.$message.error('尺码不能为空，请配置')
          return false
        }
        const price = Number(this.data.Price)
        if (isNaN(price) || price <= 0) {
          this.$message.error('商品价不能小于等于0')
          return false
        }
        const settlePrice = Number(this.data.SettlePrice)
        if (!this.data.SettlePrice || settlePrice < 0 || (this.data.SettleType == 1 && settlePrice == 0)) {
          this.data.SettlePrice = null
        } else if ((this.data.SettleType == 0 && settlePrice < 0) || (this.data.SettleType == 1 && settlePrice >= price)) {
          this.$message.error('商品客户价不能小于0')
          return false
        }
        this.data.UserPrice = this.data.Price
        const param = JSON.parse(JSON.stringify(this.data))
        let result
        this.loading = true
        if (this.isNew) {
          result = await submit('/api/product/doAdd', param).finally(() => {
            this.loading = false
          })
        } else {
          result = await submit('/api/product/doEdit', param).finally(() => {
            this.loading = false
          })
        }
        this.handleClose()
        this.$message.success('保存成功')
        this.$emit('handleSearch')
      })
    },
    handleClose() {
      this.visible = false
      this.data = {}
      this.colors = []
      this.sizes = []
      this.$refs.editForm.resetFields()
    },
    uploadImgSuccess(response) {
      if (successCode.includes(response.code)) {
        this.data.DefaultImage = response.data
      } else {
        this.$message({
          type: 'error',
          message: response.msg,
        })
      }
    },
    uploadImgError() {
      this.$message({
        type: 'error',
        message: '上传失败',
      })
    },
    colorsChange() {
      this.data.Colors = this.colors.join(',')
    },
    sizesChange() {
      this.sizes = this.sizes.sort(function (a, b) {
        if (a !== b) return a < b ? -1 : 1
        return 0
      })
      this.data.Sizes = this.sizes.join(',')
    },
  },
}
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;

  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
